import RESTApiEndPoints from "@/services/rest-api-end-points";
import ICompany from "@/models/company";
import IShip from "@/models/ship";
import axiosService from "@/services/axios-service";

export default class CompaniesService {
  public async get() {
    const response = await axiosService.get<ICompany[]>(RESTApiEndPoints.companiesUrl());
    return response.data;
  }
  public async getShips(companyId: number) {
    const response = await axiosService.get<IShip[]>(
      `${RESTApiEndPoints.companiesUrl()}/ships/${companyId}`
    );
    return response.data;
  }
}
